/**
 * AI CONTEXT: storage - Resolve and display S3 images with graceful fallback
 * Journal: J-20250811-02
 */

import React, { useEffect, useState } from 'react';
import { getImageUrlFromKey } from '../services/storage';
import { getAssetUrl } from '../utils/assetUtils';

const S3Image = ({ s3KeyOrUrl, alt = '', className = '', fallback = '/files/Logo.png' }) => {
  const [src, setSrc] = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      if (!s3KeyOrUrl) { setSrc(getAssetUrl(fallback)); return; }
      if (s3KeyOrUrl.startsWith('s3:')) {
        const url = await getImageUrlFromKey(s3KeyOrUrl);
        if (!cancelled) setSrc(url || getAssetUrl(fallback));
      } else if (/^https?:\/\//.test(s3KeyOrUrl)) {
        setSrc(s3KeyOrUrl);
      } else {
        setSrc(getAssetUrl(s3KeyOrUrl));
      }
    })();
    return () => { cancelled = true; };
  }, [s3KeyOrUrl, fallback]);

  if (!src) return null;
  return (
    <img
      src={src}
      alt={alt}
      className={className}
      onError={(e) => { e.currentTarget.onerror = null; e.currentTarget.src = getAssetUrl(fallback); }}
    />
  );
};

export default S3Image;


